import React, {Component} from 'react';
import {connect} from 'react-redux';
import Formsy from 'formsy-react';
import {
    createTariffByAPI,
    updateTariffByAPI,
    closeTariffModal
} from '../salary.actions';
import translator from '../../../components/localization/translator';
import {
    Modal,
    Panel,
    Glyphicon,
    ControlLabel,
    Button,
    Checkbox,
    ButtonToolbar,
    ToggleButtonGroup,
    ToggleButton
} from 'react-bootstrap';
import tariffConf from '../../../config/salary';
import {
    SALARY_FIELDS,
    DISTRIBUTOR_TYPES,
    TRANSPORT_ICONS,
    MEASUREMENT_TYPE,
    SELECT,
    ORDER_TYPES
} from '../../../config/constants';
import FooterButtons from '../../../components/common/elements/FooterButtons';
import FormInput from '../../../components/common/elements/FormInput';
import './Tariff.css';
import Select from "react-select";
import carIcon from '../../../assets/car-alt-solid.svg';
import bikeIcon from '../../../assets/biking-solid.svg';
import motobikeIcon from '../../../assets/motorcycle-solid.svg';
import scooterIcon from '../../../assets/electro-scooter.svg';

class TariffDetails extends Component {
    constructor(props) {

        super(props);
        this.clearChangedData();
        this.state = {
            value: DISTRIBUTOR_TYPES.CAR,
            isChecked: false,
            isDisabled: true,
            measurementToBeTransferredUnique: MEASUREMENT_TYPE.PERCENT,
            measurementToBeTransferredSecondary: MEASUREMENT_TYPE.PERCENT,
            amountToBeTransferredUnique: '',
            amountToBeTransferredSecondary: ''
        };
    }

    setChangedData = (key, value) => {
        this.changedData[key] = value;
    }
    handleTransferTypeChange = (field, value) => {
        this.setState({[field]: value});
    };
    handleMeasurementTypeChange = (field, value) => {
        this.setState({[field]: Number(value)});
    };


    clearChangedData = () => {
        this.changedData = {
            distributorType: DISTRIBUTOR_TYPES.CAR.id,
            bonus: {limits: [{min: 0, max: 0, price: 0}], applyAll: false},
            uniqueOrderRanges: [{min: 0, max: 0, price: 0}],
            secondaryOrderRanges: [{min: 0, max: 0, price: 0}]
        };
    }

    toNumber(data) {
        for (const key in data) {
            if (
                key === 'baseSalary' ||
                key === 'minOrdersCount' ||
                key === 'minWorkingDays' ||
                key === 'amountToBeTransferredUnique' ||
                key === 'amountToBeTransferredSecondary'
            ) {
                data[key] = Number(data[key]);
            } else if (key === 'bonus') {
                data[key].limits.map(item => {
                    item.min = Number(item.min);
                    item.max = Number(item.max);
                    item.price = Number(item.price);
                    return item;
                });
            } else if (key === 'uniqueOrderRanges' || key === 'secondaryOrderRanges') {
                data[key].map(item => {
                    item.min = Number(item.min);
                    item.max = Number(item.max);
                    item.price = Number(item.price);
                    return item;
                });
            }
        }
        return data;
    }

    save() {

        this.changedData.measurementToBeTransferredUnique = this.state.measurementToBeTransferredUnique;
        this.changedData.measurementToBeTransferredSecondary = this.state.measurementToBeTransferredSecondary;

        this.toNumber(this.changedData);

        const id = this.changedData._id;
        if (id) {
            const data = {...this.changedData};
            delete data._id;
            this.update(id, data, () => {
                this.cancel();
            });
        } else {
            this.create(this.changedData, () => {
                this.cancel();
            });
        }
    }

    create = (data, cb) => {
        this.props.createTariffByAPI(data, cb);
    }

    update = (id, data, cb) => {
        this.props.updateTariffByAPI(id, data, cb);
    }

    cancel = () => {
        this.props.closeTariffModal();
        this.setState({value: DISTRIBUTOR_TYPES.CAR, isChecked: false, isDisabled: true});
        this.clearChangedData();
    }

    renderFooter() {
        return (
            <Modal.Footer>
                <FooterButtons
                    cancelButton={translator.translate("_cancel_")}
                    saveButton={translator.translate("_save_")}
                    save={this.save.bind(this)}
                    cancel={this.cancel}
                    isDisabled={this.state.isDisabled}
                />
            </Modal.Footer>
        );
    }


    disableButton = () => {
        this.setState({isDisabled: true});
    }

    enableButton = () => {
        this.setState({isDisabled: false});
    }

    getTitle() {
        const selectedTariff = this.props.tariffDetails.selectedTariff || {};
        return <b>{selectedTariff._id ? translator.translate('_update_tariff_') : translator.translate('_create_new_tariff_')}</b>;
    }

    renderAddButton(fieldGroups) {
        return (
            <Button
                bsStyle='link'
                bsSize='xsmall'
                onClick={() => {
                    fieldGroups.push({min: 0, max: 0, price: 0});
                    this.setState({fieldGroups});
                }}>
                <Glyphicon glyph={'plus-sign'}/>
            </Button>
        );
    }

    renderDeleteButton(fieldGroups, group) {
        return (
            <Button
                bsStyle='link'
                onClick={() => {
                    const possition = fieldGroups.indexOf(group);
                    fieldGroups.splice(possition, 1);
                    this.setState({fieldGroups});
                }}>
                <Glyphicon glyph={'trash trash-button red-color'}/>
            </Button>
        );
    }

    renderApplyAll() {
        const applyAll = this.props.tariffDetails.selectedTariff && this.props.tariffDetails.selectedTariff.bonus.applyAll;
        return (
            <div className="flex-row">
                <span className="right-margin">{translator.translate("_apply_all_")}</span>
                <Checkbox
                    inline
                    checked={applyAll}
                    onChange={(e) => {
                        this.changedData.bonus.applyAll = e.target.checked;
                        this.setState({isChecked: e.target.checked});
                    }}>
                </Checkbox>
            </div>
        );
    }

    handleChange = (e) => {
        this.setChangedData('distributorType', e.id);
        this.setState({value: e});
    }

    renderTransportType() {
        return (
            <div className="flex-row">
                <ControlLabel className="label-width">{`${translator.translate("_choose_picture_")}:`}</ControlLabel>
                <ButtonToolbar>
                    <ToggleButtonGroup
                        type="radio"
                        name="transport-type"
                        value={DISTRIBUTOR_TYPES.typeById(this.changedData.distributorType)}
                        onChange={this.handleChange}>
                        <ToggleButton value={DISTRIBUTOR_TYPES.CAR} className="right-margin" style={{padding: '4px 8px'}}>
                            <img src={carIcon} className="image-size" alt="car" style={{width: '24px', height: '24px', display: 'block'}}/>
                        </ToggleButton>
                        <ToggleButton value={DISTRIBUTOR_TYPES.BIKE} className="right-margin" style={{padding: '4px 8px'}}>
                            <img src={bikeIcon} className="image-size" alt="bike" style={{width: '24px', height: '24px', display: 'block'}}/>
                        </ToggleButton>
                        <ToggleButton value={DISTRIBUTOR_TYPES.MOTOBIKE} className="right-margin" style={{padding: '4px 8px'}}>
                            <img src={motobikeIcon} className="image-size" alt="motobike" style={{width: '24px', height: '24px', display: 'block'}}/>
                        </ToggleButton>
                        <ToggleButton value={DISTRIBUTOR_TYPES.SCOOTER} className="right-margin" style={{padding: '4px 8px'}}>
                            <img src={scooterIcon} className="image-size" alt="scooter" style={{width: '24px', height: '24px', display: 'block'}}/>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </ButtonToolbar>
            </div>
        );
    }

    onChangeHandler = (e, key, options, index) => {
        if (!key) {
            this.changedData[options.name] = e.target.value;
        } else if (key === SALARY_FIELDS.BONUS.name) {
            this.changedData[key].limits[index][options.name] = e.target.value;
        } else {
            this.changedData[key][index][options.name] = e.target.value;
        }
        this.setState({[options.name]: e.target.value});
    }

    renderEditableFields = (options, index, fieldGroups, key) => {
        const value = (key ? fieldGroups[index][options.name] : this.changedData[options.name]) || '';
        if (options.name === 'distributorType') {
            return null;
        }
        return (
            <FormInput
                {...options}
                id={key ? `${key}-${options.name}-${index}` : `${options.name}-${index}`}
                key={index}
                value={value}
                onChange={(e) => this.onChangeHandler(e, key, options, index)}
            />
        );
    }

    renderFields(fieldGroups, id, key) {
        return (
            <div>
                {fieldGroups.map((group, index) => {
                    return (
                        <div className="flex-row" key={`${key}-${index}`}>
                            {tariffConf.getColumns(id).map((field) => {
                                return (
                                    <div className="right-margin" key={`${field.name}-${index}`}>
                                        {this.renderEditableFields(field, index, fieldGroups, key)}
                                    </div>
                                );
                            })}
                            <div>{fieldGroups.length > 1 ? this.renderDeleteButton(fieldGroups, group) : null}</div>
                        </div>
                    );
                })}
            </div>
        );
    }

    render() {
        const selectedTariff = this.props.tariffDetails.selectedTariff;

        if (selectedTariff) {
            this.changedData = selectedTariff;
        }

        return (
            <Modal
                bsSize='large'
                show={this.props.tariffDetails.showModal}
                onHide={this.cancel}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.getTitle()}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <Formsy onValid={this.enableButton} onInvalid={this.disableButton}>
                        <Panel className='w-100'>
                            <Panel.Heading>{translator.translate('_define_tariff_')}</Panel.Heading>
                            <Panel.Body>
                                {tariffConf.getColumns(SALARY_FIELDS.TARIFF.id).map(this.renderEditableFields)}
                                {this.renderTransportType()}
                            </Panel.Body>
                        </Panel>
                        <Panel className='w-100'>
                            <Panel.Heading className="flex-box space-between">
                                <div>{translator.translate('_bonus_')}{this.renderAddButton(this.changedData.bonus.limits)}</div>
                                {this.renderApplyAll()}
                            </Panel.Heading>
                            <Panel.Body className="panel-scroll">
                                {this.renderFields(this.changedData.bonus.limits, SALARY_FIELDS.BONUS.id, SALARY_FIELDS.BONUS.name)}
                            </Panel.Body>
                        </Panel>
                        <div className="flex-box">
                            <Panel className='w-100'>
                                <Panel.Heading>
                                    {translator.translate('_unique_')}{this.renderAddButton(this.changedData.uniqueOrderRanges)}
                                </Panel.Heading>
                                <Panel.Body className="panel-scroll">
                                    {this.renderFields(this.changedData.uniqueOrderRanges, SALARY_FIELDS.UNIQUE.id, SALARY_FIELDS.UNIQUE.name)}
                                </Panel.Body>
                            </Panel>
                            <Panel className='w-100'>
                                <Panel.Heading>
                                    {translator.translate('_secondary_')}{this.renderAddButton(this.changedData.secondaryOrderRanges)}
                                </Panel.Heading>
                                <Panel.Body className="panel-scroll">
                                    {this.renderFields(this.changedData.secondaryOrderRanges, SALARY_FIELDS.SECONDARY.id, SALARY_FIELDS.SECONDARY.name)}
                                </Panel.Body>
                            </Panel>
                        </div>
                        <div className="flex-box">
                            <Panel className='w-100'>
                                <Panel.Heading>
                                    {translator.translate('_unique_')}
                                </Panel.Heading>
                                <Panel.Body className="panel-scroll">
                                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>

                                        <input
                                            type="number"
                                            className="form-control margin-bottom"
                                            style={{
                                                height: 34,
                                                fontSize: 14,
                                                padding: '6px 12px',
                                                boxSizing: 'border-box'
                                            }}
                                            min={0}
                                            value={this.changedData.amountToBeTransferredUnique || ''}
                                            onChange={e => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d*$/.test(value)) {
                                                    this.changedData.amountToBeTransferredUnique = value;
                                                    this.setState({amountToBeTransferredUnique: value});
                                                }
                                            }}
                                        />
                                        <select
                                            className="form-control default-font"
                                            id="measurementToBeTransferredUnique"
                                            name="measurementToBeTransferredUnique"
                                            value={this.state.measurementToBeTransferredUnique}
                                            onChange={e => {
                                                const selectedValue =Number(e.target.value);
                                                this.setState({measurementToBeTransferredUnique: selectedValue});
                                                this.changedData.measurementToBeTransferredUnique = selectedValue;
                                            }}
                                        >
                                            <option value={MEASUREMENT_TYPE.PERCENT}>%</option>
                                            <option
                                                value={MEASUREMENT_TYPE.FIXED}>{translator.translate('_amount_')}</option>
                                        </select>

                                    </div>
                                </Panel.Body>
                            </Panel>
                            <Panel className='w-100'>
                                <Panel.Heading>
                                    {translator.translate('_secondary_')}
                                </Panel.Heading>
                                <Panel.Body className="panel-scroll">

                                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                        <input
                                            type="number"
                                            className="form-control margin-bottom"
                                            style={{
                                                height: 34,
                                                fontSize: 14,
                                                padding: '6px 12px',
                                                boxSizing: 'border-box'
                                            }}
                                            min={0}
                                            value={this.changedData.amountToBeTransferredSecondary || ''}
                                            onChange={e => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d*$/.test(value)) {
                                                    this.changedData.amountToBeTransferredSecondary = value;
                                                    this.setState({amountToBeTransferredSecondary: value});
                                                }
                                            }}
                                        />
                                        <select
                                            className="form-control default-font"
                                            id="measurementToBeTransferredSecondary"
                                            name="measurementToBeTransferredSecondary"
                                            value={this.state.measurementToBeTransferredSecondary}
                                            onChange={e => {
                                                const selectedValue = Number(e.target.value);
                                                this.setState({measurementToBeTransferredSecondary: selectedValue});
                                                this.changedData.measurementToBeTransferredSecondary = selectedValue;
                                            }}
                                        >
                                            <option value={MEASUREMENT_TYPE.PERCENT}>%</option>
                                            <option
                                                value={MEASUREMENT_TYPE.FIXED}>{translator.translate('_amount_')}</option>
                                        </select>

                                    </div>

                                </Panel.Body>
                            </Panel>
                        </div>

                    </Formsy>
                </Modal.Body>
                {this.renderFooter()}
            </Modal>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        tariffDetails: state.tariffDetails
    };
};
export default connect(mapStateToProps, {
    createTariffByAPI,
    updateTariffByAPI,
    closeTariffModal
})(TariffDetails);
